import { render } from "./errorPage.vue?vue&type=template&id=20a4eeba"
import script from "./errorPage.vue?vue&type=script&lang=js"
export * from "./errorPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\prj\\asan\\asan_tpps_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__